module.exports = __webpack_public_path__ + "img/1525658519.7bb638af.jpg";